import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useContext,
} from "react";
import {
  HIDE_ASSIGN_DROPDOWN_TABS,
  TAB_NAME,
  TOAST_TYPE,
  USERTYPES,
} from "../../../../constants/Constants";
import CustomDropDown from "../../../../components/CustomDropDown/CustomDropDown";
import {
  Dropdown,
  TooltipHost,
  PrimaryButton,
  ContextualMenu,
  IconButton,
  Stack,
  Icon,
} from "@fluentui/react";
import {
  assignButtonStyle,
  dropdownStyles,
  reAssignButtonStyle,
  radiologistNameStack,
  radiologistStackAssigned,
  reAssignButtonFirmStyle,
  hospitalStackStyles,
  superAdminReAssignButtonStyle,
  hideButtonStyle,
} from "../../helpers/initData";
import { t } from "i18next";
import { RowBadgeStatic } from "../RadiologistDetails";
import EyeIcon from "../../../../components/SVGComponents/EyeIcon";
import { AddLinkIcon, CancelIcon } from "@fluentui/react-icons-mdl2";
import AssignmentChainPopUp from "./AssignmentChainPopUp";
import studylistContext from "../../../../context/studylist/StudylistContext";
import toastContext from "../../../../context/toast/ToastContext";
import userContext from "../../../../context/users/UserContext";
import { AssignmentDropDown } from "./FirmRadiologist";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { getEnv } from "../../../../helpers/EnvHelper";

const SuperAdminRadiologist = (props) => {
  const { unassignProvider, dataQueryState, setDataQueryState, roles,assignmentChaiHoverPopupId,setAssignmentChaiHoverPopupId } =
    useContext(studylistContext);
  const { getConsistentDateFormat } = useContext(studyReportContext);
  const { showToastv2 } = useContext(toastContext);
  const { userId } = useContext(userContext);

  const assignmentList = props.data.row.original.assignmentList;

  const notAssignedYet = props.notAssignedYet;
  const [showAssignmentChain, setShowAssignmentChain] = useState(false);
  const [isHovered,setIsHovered] = useState(false);
  const [loadingChaining, setLoadingChaining] = useState(false);
  const [delayHandler, setDelayHandler] = useState(null);

  useEffect(()=>{
    if(isHovered){
      if(assignmentChaiHoverPopupId != props.data.row.original.id){
        setAssignmentChaiHoverPopupId(props.data.row.original.id);
      } 
    }
  },[isHovered])

  useEffect(()=>{
    if(assignmentChaiHoverPopupId != props.data.row.original.id){
      setShowAssignmentChain(false);
    }
  },[assignmentChaiHoverPopupId])

  const [showContxtMenuForChain, setShowContxtMenuForChain] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
  });

  const [showReassignObj, setShowReassingObj] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
  });

  const handleContextMenuClick = (index) => {
    console.log("---- Index ----", index);
    setShowContxtMenuForChain(() => {
      const newItem = { ...showContxtMenuForChain };
      newItem[index] = true;
      return newItem;
    });
  };

  const getItemOfClosedStudy = (index, item) => {
    let assignmentList = props.data.row.original.assignmentList;
    console.log("--- Selected Item ---", item, assignmentList);
    for (let i = 1; i < props.data.row.original.assignmentList.length; i++) {
      if (
        (item.providerId === assignmentList[i].firmId ||
          item.providerId === null ||
          item.providerId === undefined) &&
        props.data.row.original.assignmentList[i]?.closed != 0 &&
        props.data.row.original.assignmentList[i]?.reportDoneStatus != 2
      ) {
        return props.data.row.original.assignmentList[i];
      }
    }
    return -1;
  };

  const handleRemoveChildAssignments = (
    data,
    responseObject,
    lock,
    currentIndex
  ) => {
    let newIndex = -1;
    let newData = dataQueryState?.data?.rows.filter((row, index) => {
      if (row.id == data.id) {
        newIndex = index;
        return true;
      }
      return false;
    });
    if (lock) {
      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState,
        };
        newValue.data.rows[newIndex].assignmentList[currentIndex][
          "providerName"
        ] = responseObject?.reportingProviderName;
        newValue.data.rows[newIndex].assignmentList[currentIndex][
          "providerId"
        ] = "R" + userId;
        return newValue;
      });
    } else {
      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState,
        };
        newValue.data.rows[newIndex].assignmentList[0].providerName = "";
        newValue.data.rows[newIndex].assignmentList[0].providerId = undefined;
        const newAssignmentList =
          newValue.data.rows[newIndex].assignmentList[0];
        newValue.data.rows[newIndex].assignmentList = [newAssignmentList];

        return newValue;
      });
    }
  };

  const handleReassignObjectUpdate = (index) => {
    console.log("---- Index ----", index);
    if (
      props.data.row.original.assignmentList[0].providerId != null &&
      props.data.row.original.assignmentList[0].closed == 0 &&
      props.data.row.original.reportDoneStatus < 2
    ) {
      unassignProvider(
        props.data.row.original,
        props.data,
        setLoadingChaining,
        handleRemoveChildAssignments,
        index
      );
    } else {
      showToastv2(
        TOAST_TYPE.INFO,
        t("string-literals.assignment-is-compulsory")
      );
      setShowAssignmentChain(false);
      handleRemoveChildAssignments(props.data.row.original, "", false, index);
    }
  };

  const checkForNumberOfAssignment = () => {
    if (
      assignmentList.length >= 1 &&
      assignmentList[0].providerId != null &&
      !assignmentList[0].providerId?.startsWith("R")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkForProviderAndRadiologist = () => {
    if (assignmentList[0].providerId != null) {
      return true;
    } else {
      return false;
    }
  };

  const getAssignmentCount = () => {
    if (
      assignmentList[assignmentList.length - 1].providerId != null &&
      assignmentList[assignmentList.length - 1].providerId?.startsWith("R")
    ) {
      return assignmentList.length;
    } else {
      return assignmentList.length - 1;
    }
  };

  const hideAssignments = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowAssignmentChain(false);
      }, 300)
    );
  };

  const showAssignments = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setShowAssignmentChain(true);
      }, 300)
    );
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          position: "relative",
        }}
      >
        {(
          <Stack horizontal style={hospitalStackStyles}>
            <div style={{ display: "flex" }}>
              {checkForProviderAndRadiologist() && (
                <div className="radiologist-column-progress-number-line">
                  {checkForNumberOfAssignment() && (
                    <div
                      onClick={() => setShowAssignmentChain((prev) => !prev)}
                      className="radiologist-column-progress-number-text"
                    >
                      <span className="radiolgist-column-progress-number-text-style">
                        {getAssignmentCount()}
                      </span>
                    </div>
                  )}
                </div>
              )}
              {checkForProviderAndRadiologist() ? (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <RowLevelProvider
                    roles={roles}
                    data={props.data}
                    handleReassignObjectUpdate={handleReassignObjectUpdate}
                    tabId={props.tabId}
                  />
                  <RowLevelRadiologist
                    roles={roles}
                    data={props.data}
                    handleReassignObjectUpdate={handleReassignObjectUpdate}
                  />
                </div>
              ) : (
                <>
                  {props.tabId != TAB_NAME.CLOSED ? (
                    props.data.row.depth === 0 && <AssignmentDropDown
                      data={props.data}
                      superAdmin={true}
                      getSelectedValue={props.getSelectedValue}
                      unselectRadiologist={props.unselectRadiologist}
                      handleSelection={props.handleSelection}
                    />
                  ) : (
                    <span
                      style={{ marginTop: "8px" }}
                      className="study-list-history-not-available"
                    >
                      {t("string-literals.cannot-assign-provider")}
                    </span>
                  )}
                </>
              )}
              {checkForNumberOfAssignment() && (
                <>
                  {props.tabId != TAB_NAME.CLOSED ? (
                    <Icon
                    onMouseEnter={() => {showAssignments();setIsHovered(true)}}
                    onMouseLeave={()=>{setIsHovered(false)}}
                    onClick={()=> showAssignments()}
                      iconName="MoreVertical"
                      style={{
                        marginTop:
                          getEnv("REACT_APP_HYBRID_MODE") == "true"
                            ? "0px"
                            : "3px",
                      }}
                      className={`assignment-chain-link 
              ${
                // props.data.row.original.assignmentList[0].providerId != null &&
                // props.data.row.original.assignmentList[0].providerId !=
                //   undefined
                //   ? " assignment-chain-hightlight"
                //   : ""
                ""
              }
              `}
                    ></Icon>
                  ) : (
                    props.data.row.original.assignmentList[0].providerId !=
                      null &&
                    props.data.row.original.assignmentList[0].providerId !=
                      undefined && (
                      <Icon
                      onMouseEnter={() => {showAssignments();setIsHovered(true)}}
                      onMouseLeave={()=>{setIsHovered(false)}}
                      onClick={()=> showAssignments()}
                        iconName="MoreVertical"
                        style={{
                          marginTop:
                            getEnv("REACT_APP_HYBRID_MODE") == "true"
                              ? "0px"
                              : "3px",
                        }}
                        className={`assignment-chain-link 
            ${
              // props.data.row.original.assignmentList[0].providerId != null &&
              // props.data.row.original.assignmentList[0].providerId != undefined
              //   ? " assignment-chain-hightlight"
              //   : ""
              ""
            }`}
                      ></Icon>
                    )
                  )}
                </>
              )}
            </div>
            {/* <span className="studylist-assignment-text-style studylist-assignment-return-text">
              Assignment date: {props.data.row.original.uploadDateDisplay}
            </span> */}
          </Stack>
        )}

        {props.data.row.original.assignmentList.length > 0 && (
          <AssignmentChainPopUp
            show={showAssignmentChain}
            onClickOutside={() => {
              //setShowAssignmentChain(false);
              hideAssignments();
            }}
            setShowAssignmentChain={setShowAssignmentChain}
            hideAssignments={hideAssignments}
            data={props.data}
            showReassignObj={showReassignObj}
            handleReassignObjectUpdate={handleReassignObjectUpdate}
            getItemOfClosedStudy={getItemOfClosedStudy}
            handleContextMenuClick={handleContextMenuClick}
            showContxtMenuForChain={showContxtMenuForChain}
            setShowContxtMenuForChain={setShowContxtMenuForChain}
            getSelectedValue={props.getSelectedValue}
            loadingChaining={loadingChaining}
            handleSelection={props.handleSelection}
            handleRevertCloseStudyModal={props.handleRevertCloseStudyModal}
            handleSendReport={props.handleSendReport}
            tabId={props.tabId}
            unselectRadiologist={props.unselectRadiologist}
          />
        )}
      </div>
    </>
  );
};

export default SuperAdminRadiologist;

export const RowLevelProvider = (props) => {
  const { isActiveData } = useContext(userContext);
  const assignmentList = props.data.row.original.assignmentList;

  const checkForProviderExist = () => {
    let assignmentList = props.data.row.original.assignmentList;
    if (
      assignmentList[0].providerId != null &&
      assignmentList[0].providerId?.startsWith("F")
    ) {
      return true;
    } else {
      return false;
    }
  };

  const checkToShowReassignButton = () => {
    if (
      props.data.row.original.assignmentList[0].providerId != undefined &&
      props.data.row.original.assignmentList[0].providerId != 0 &&
      !(props.data.row.original.assignmentList[0].closed == 0 ? false : true) &&
      props.data.row.original.reportDoneStatus < 2
    ) {
      return props.data.row.original.allowAssignment ? true : false;
    } else {
      return false;
    }
  };

  return (
    <>
      <div style={{ display: "flex", marginTop: "3px" }}>
        <RowBadgeStatic name={"P"} tooltipText={"Provider"} />
        {checkForProviderExist() &&
        props.data.row.original.assignmentList[0].providerName != "" ? (
          <CustomToolTipHost
            content={`${t("navbar.provider")}: ${
              props.data.row.original.assignmentList[0]?.closedByProvider
                ? `(${t("label.closed")}) `
                : ""
            }
            ${props.data.row.original.assignmentList[0].providerName}`}
            id={
              "tooltip_" +
              props.data.row.original.assignmentList[0].providerName
            }
          >
            <span
              className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
              style={{ width: "120px", display: "block" }}
            >
              &nbsp;&nbsp;
              {props.data.row.original.assignmentList[0]?.closedByProvider
                ? `(${t("label.closed")}) `
                : ""}
              {props.data.row.original.assignmentList[0].providerName != ""
                ? props.data.row.original.assignmentList[0].providerName
                : "-"}
            </span>
          </CustomToolTipHost>
        ) : (
          <CustomToolTipHost content={t("label.not-assigned")} id={"tooltip_Not Assigned"}>
            <span
              className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
              style={{ width: "120px", display: "block" }}
            >
              &nbsp;&nbsp;{t("label.not-assigned")}
            </span>
          </CustomToolTipHost>
        )}
        {props.data.row.depth === 0 && (
          <CustomToolTipHost content={t("button.reassign")}>
            <PrimaryButton
              iconProps={{
                iconName: "Switch",
                cursor: "pointer",
              }}
              onClick={() => props.handleReassignObjectUpdate(0)}
              styles={
                checkToShowReassignButton()
                  ? superAdminReAssignButtonStyle
                  : hideButtonStyle
              }
              disabled={!isActiveData}
            />
          </CustomToolTipHost>
        )}
      </div>
    </>
  );
};

export const RowLevelRadiologist = (props) => {
  const assignmentList = props.data.row.original.assignmentList;
  const { getConsistentDateFormat } = useContext(studyReportContext);
  const checkForRadiologistExist = () => {
    let assignmentList = props.data.row.original.assignmentList;
    if (
      assignmentList[assignmentList.length - 1].providerId != null &&
      assignmentList[assignmentList.length - 1].providerId?.startsWith("R")
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <RowBadgeStatic name={"R"} tooltipText={t("radiologist.radiologist")} />
        <>
          {checkForRadiologistExist() &&
          assignmentList[assignmentList.length - 1].providerName != "" ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <CustomToolTipHost
                content={
                 `${t("radiologist.radiologist")}: ` +
                  assignmentList[assignmentList.length - 1].providerName
                }
                id={
                  "tooltip_" +
                  assignmentList[assignmentList.length - 1].providerName
                }
              >
                <span
                  className="study-list-assignment-details-text study-list-row-badge study-list-min-width"
                  style={{ width: "160px", display: "block" }}
                >
                  &nbsp;&nbsp;
                  {assignmentList[assignmentList.length - 1].providerName != ""
                    ? assignmentList[assignmentList.length - 1].providerName
                    : "-"}
                </span>
              </CustomToolTipHost>
              <span className="studylist-assignment-text-style-super-admin studylist-assignment-return-text">
                &nbsp;&nbsp;{t("sorting.study-list.assignment-on")}:{" "}
                {getConsistentDateFormat(
                  assignmentList[assignmentList.length - 1]
                    .assignmentDateDisplay
                )}
              </span>
            </div>
          ) : (
            <div
              className="studylist-align-display-center"
              style={{ position: "relative" }}
            >
              <CustomToolTipHost content={t("label.not-assigned")} id={"tooltip_Not Assigned"}>
                <span
                  className="study-list-assignment-details-text study-list-row-badge study-list-uploaded study-list-min-width"
                  style={{
                    width: "160px",
                    display: "block",
                    fontStyle: "italic",
                    position: "relative",
                  }}
                >
                  &nbsp;&nbsp;{t("label.not-assigned")}
                </span>
              </CustomToolTipHost>
              <div className="studylist-red-dot"></div>
            </div>
          )}
        </>
      </div>
    </>
  );
};
